import React from 'react';
import {
  arrayBuilderItemSubsequentPageTitleUI,
  currentOrPastDateUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateDateRange } from 'platform/forms-system/src/js/validation';

import { providerFacilityItemSchema } from '../../../schema';

const { treatmentDateRange } = providerFacilityItemSchema.properties;
const { from, to } = treatmentDateRange.properties;

const TreatmentStartDateDescription = () => (
  <>
    <h4>Treatment start date</h4>
    <p>
      If you’re being treated for multiple conditions at this provider, enter
      the date you first visited.
    </p>
  </>
);

const TreatmentEndDateDescription = () => (
  <>
    <h4>Treatment end date</h4>
    <p>
      If treatment is ongoing for one or more conditions at this location, you
      can enter today’s date.
    </p>
  </>
);

// Note from the ticket: a full date range (rather than VA's single
// month/year) is a "rogue" use of the date component; may be revisited after
// midpoint design review.
//
// The "Treatment start/end date" info blocks are separate `view:` fields
// (rather than `currentOrPastDateRangeUI`'s built-in `ui:description`)
// because the web component always renders its description *after* the
// field's own label and hint, not before — see the screenshot.
export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => `Treatment dates at ${formData?.providerFacilityName}`,
      'These dates let us know which medical records to request on your behalf. You can give estimates for these dates, if needed.',
    ),
    treatmentDateRange: {
      'ui:validations': [
        {
          validator: (errors, fieldData, formData, schema, uiSchema) =>
            validateDateRange(
              errors,
              fieldData,
              formData,
              schema,
              uiSchema,
              true,
            ),
        },
      ],
      'view:treatmentStartDateInfo': {
        'ui:description': TreatmentStartDateDescription,
      },
      from: currentOrPastDateUI({
        title: 'When did your treatment start?',
        monthSelect: false,
      }),
      'view:treatmentEndDateInfo': {
        'ui:description': TreatmentEndDateDescription,
      },
      to: currentOrPastDateUI({
        title: 'When did your treatment end?',
        monthSelect: false,
      }),
    },
  },
  schema: {
    type: 'object',
    properties: {
      treatmentDateRange: {
        type: 'object',
        required: treatmentDateRange.required,
        properties: {
          'view:treatmentStartDateInfo': { type: 'object', properties: {} },
          from,
          'view:treatmentEndDateInfo': { type: 'object', properties: {} },
          to,
        },
      },
    },
  },
};
